// extracted by mini-css-extract-plugin
module.exports = {"tablet":"min-width: 48em","proFilter":"ProFilter_proFilter__M8Q1s"};